import { forwardRef } from 'react';
import { useTheme } from 'styled-components';
import Highlight, { defaultProps } from 'prism-react-renderer';
import { StyledPre } from './styled';

const Pre = forwardRef(({ content, language, ...props }, ref) => {
  const theme = useTheme();

  const baseTheme = {
    plain: {
      backgroundColor: theme.colors.slate[3],
      color: theme.alias.fg,
    },
    styles: [
      {
        types: ['comment', 'function', 'operator', 'punctuation', 'keyword'],
        style: {
          color: theme.alias.subtle,
        },
      },
    ],
  };

  return (
    <Highlight
      {...defaultProps}
      theme={baseTheme}
      code={content}
      language={language}
    >
      {({ className, style, tokens, getLineProps, getTokenProps }) => (
        <StyledPre className={className} style={style} ref={ref} {...props}>
          <div>
            {tokens.map((line, i) => (
              <div {...getLineProps({ line, key: i })}>
                {line.map((token, key) => (
                  <span {...getTokenProps({ token, key })} />
                ))}
              </div>
            ))}
          </div>
        </StyledPre>
      )}
    </Highlight>
  );
});

export default Pre;
